import { useEffect } from 'react'
import { Link as RouterLink, useParams } from 'react-router-dom'
import { Box, Breadcrumbs, Link as MuiLink, Typography } from '@mui/material'
import { Home as HomeIcon, NavigateNext as NavigateNextIcon } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { DashboardLayout } from '@/components/layout/DashboardLayout'
import { useUserStore } from '@/stores/userStore'
import { ROUTES } from '@/utils/constants'
import { ActivityPage } from '../ActivityPage'
import '@/styles/dashboard.css'

/** Админ: активность любого пользователя (/admin/users/:id/activity) */
export function AdminUserActivityPage() {
  const { id } = useParams<{ id: string }>()
  const { t } = useTranslation()
  const userId = id ? parseInt(id, 10) : NaN
  const currentUser = useUserStore((state) => state.currentUser)
  const fetchUser = useUserStore((state) => state.fetchUser)

  useEffect(() => {
    if (Number.isNaN(userId)) return
    fetchUser(userId).catch(() => {})
  }, [userId, fetchUser])

  const isLoaded = currentUser !== null && currentUser.id === userId

  const userName = isLoaded
    ? [currentUser.surname, currentUser.first_name].filter(Boolean).join(' ').trim() ||
      currentUser.email
    : undefined

  // Роли просматриваемого пользователя; не загрузились — показываем оба lesson-фильтра
  const subjectRoles = isLoaded && currentUser.roles?.length
    ? currentUser.roles.map((role) => role.slug)
    : undefined

  return (
    <DashboardLayout>
      <Box sx={{ p: { xs: 2, sm: 3 }, pb: 0 }}>
        <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
          <MuiLink
            component={RouterLink}
            to={ROUTES.DASHBOARD}
            underline="hover"
            sx={{ display: 'flex', alignItems: 'center' }}
          >
            <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
            {t('dashboard.home')}
          </MuiLink>
          <MuiLink component={RouterLink} to={ROUTES.ADMIN_USERS} underline="hover">
            {t('admin.users.title')}
          </MuiLink>
          {!Number.isNaN(userId) && (
            <MuiLink
              component={RouterLink}
              to={ROUTES.ADMIN_USER_VIEW(userId)}
              underline="hover"
            >
              {userName ?? `#${userId}`}
            </MuiLink>
          )}
          <Typography color="text.primary">{t('activity.title')}</Typography>
        </Breadcrumbs>
      </Box>

      <ActivityPage
        userId={Number.isNaN(userId) ? undefined : userId}
        userName={userName}
        subjectRoles={subjectRoles}
      />
    </DashboardLayout>
  )
}
